import {Employee} from '../../models/employee/employee.model';
import {
    LoadedSuccessAction,
    RedirectedUrlSuccessAction,
    UserActions,
    UserActionTypes
} from './user.actions';
export class UserState {
    authenticated: boolean;
    redirectedUrl: string;
    employee: Employee;
}
export const userInitialState: UserState = {
    authenticated: false,
    redirectedUrl: '/',
    employee:  new Employee()
};

export function userReducer(state: UserState = userInitialState, action: UserActions): UserState {
    switch (action.type) {
        case UserActionTypes.AUTHENTICATED_SUCCESS:
            return Object.assign({}, state, {
                authenticated: true
            });
        case UserActionTypes.REDIRECTED_URL_SUCCESS:
            return Object.assign({}, state, {
                redirectedUrl: (action as RedirectedUrlSuccessAction).payload.redirectedUrl
            });
        case UserActionTypes.LOADED_SUCCESS:
            return Object.assign({}, state, {
                employee: (action as LoadedSuccessAction).payload.employee
            });
        case UserActionTypes.LOGOUT_ACTION:
            return Object.assign({}, state, {
                authenticated: false,
                employee: new Employee()
            });
    }
    return state;
}

